// extracted by mini-css-extract-plugin
module.exports = {"root":"ProviderList_root__MAaES","provider":"ProviderList_provider__hOVAf","button":"ProviderList_button__r5DAg","loader":"ProviderList_loader__uaWFQ"};